import { Grid, Typography } from '@mui/material';
import TextInput from './TextInput';
import { helperText } from '../assets/theme/Theme';

function CustomTextInput({
	label,
	value,
	onChange,
	error,
	placeholder,
	disabled = false,
	width = '95%',
	smallerLabel = false,
	showRequiredMark = true,
}) {
	return (
		<Grid container flexDirection={'column'} marginTop={'5px'}>
			<Typography
				fontSize={smallerLabel ? '14px' : '16px'}
				color={'#7C7C7C'}
				flexDirection={'row'}
				display={'flex'}
				paddingBottom="10px">
				{label}
				{showRequiredMark && (
					<span
						style={{
							marginLeft: '2px',
							marginTop: '5px',
							color: '#FF4343',
							fontSize: '11px',
							fontWeight: 'bold',
							display: 'block',
							pointerEvents: 'none',
						}}>
						*
					</span>
				)}
			</Typography>
			<TextInput
				error={error?.status}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				width={width}
				style={{
					marginTop: '5px',
					marginBottom: '10px',
				}}
				disabled={disabled}
			/>
			<Typography style={helperText}>{error?.msg}</Typography>
		</Grid>
	);
}

export default CustomTextInput;
